// extracted by mini-css-extract-plugin
export default {"title":"_2AHsU9MIU26Gxs8giARukc","primaryImageCol":"RGcVoYQTmSCBFUCeR2RSv"};